<template>
    <div class="videopage photopage">
      <v-menu></v-menu>
      <mode v-if="loadMode"></mode>
      <div class="pagebg">
        <div class="videoage">
          <div class="bread_nav">
            <div class="left bread_item">
              <ul class="left">
                <router-link class="left tagli index" :to="{name:'index'}" tag="li" active-class="active">首页&nbsp; &gt;&nbsp;</router-link>
                <router-link class="left tagli" :to="{name:'pcVideo'}" tag="li" active-class="active">心密图文</router-link>
              </ul>
              <div class="clear clearfix"></div>
            </div>
            <div class="clear clearfix"></div>
          </div>
          <div

            class="swiper mySwiper2"
          >
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in photoList">
                <img :src="item.image" />
              </div>
            </div>
            <div class="swiper-button-next" v-show="!loadMode"></div>
            <div class="swiper-button-prev" v-show="!loadMode"></div>
            <div class="downimg" v-if="!loadMode" @click="downImage">下载</div>
          </div>
          <div thumbsSlider="" class="swiper swiper1">
            <div class="swiper-wrapper">
              <div class="swiper-slide"  v-for="item in photoList">
                <img :src="item.image"  />
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-footer></v-footer>
    </div>
</template>

<script>
  import mode from '@/components/bg/mode'
  import Swiper from '../../../../public/swiper/swiper-bundle.min';
    export default {
        name: "photo",
        components:{
          mode
        },
        data() {
            return {
               photoList:[],
               currentUrl:'',
               currentUrlImgName:'',
               loadMode:true,
            }
        },
        mounted() {
          this.getList()
        },
        methods: {
          getList(){
            let _this=this
            this.$http({
              url: '/Photo/list',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {ajax:1}
            }).then((res) => {
              this.loadMode=false
              console.log(res)
              this.loadMode=false
              if(res.data.code==0){
                this.photoList=res.data.data
                var swiper = new Swiper(".swiper1", {
                  spaceBetween: 10,
                  slidesPerView: 10,
                  freeMode: true,
                  watchSlidesProgress: true,
                });
                _this.currentUrl=_this.photoList[0].image
                var swiper2 = new Swiper(".mySwiper2", {
                  on: {
                    slideChangeTransitionEnd: function(){
                      console.log(this.activeIndex)
                      console.log(_this.photoList)
                      _this.currentUrl=_this.photoList[this.activeIndex].image
                      _this.currentUrlImgName=_this.photoList[this.activeIndex].name
                       console.log(_this.currentUrl)
                    },
                  },
                  spaceBetween: 10,
                  navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  },
                  thumbs: {
                    swiper: swiper,
                  },
                });
              }else{
                this.$layer.msg(res.data.msg)

              }
            })
            .catch((error) => {
              // error
              this.$layer.msg('网络错误，请稍后重试')
              this.loadMode=false
              console.log(error)
            })
          },
          //下载
          async downImage(){
            this.$layer.msg("正在下载,请稍后",{icon:1});//提示框
            let response = await fetch(this.currentUrl); // 内容转变成blob地址
            console.log(response)
            let blob = await response.blob();  // 创建隐藏的可下载链接
            let objectUrl = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = objectUrl;
            a.download = this.currentUrlImgName;
            a.click()
            a.remove();
            this.$layer.msg("文件下载成功",{icon:1});
          }
        }
    }
</script>

<style scoped lang="scss">
  .videoage{
    width:95rem;
    margin:0 auto 0;
    height:100%;
    box-sizing: border-box;
    padding-left:9rem;
    .bread_nav{
      padding:2rem 0;
      .bread_item{
        height:3rem;
        .tagli{
          height:3rem;
          font-size:1.1rem;
          color:#5f4009;
          line-height: 3rem;
          cursor: pointer;
        }
        .index{
          background:url("../../../assets/images/nav.png")no-repeat left center;
          background-size:1rem auto;
          padding-left:2rem;

        }
      }
    }

    .swiper1{
      .swiper-slide{
        cursor: pointer;
        opacity: 0.4;
        img{
          max-width:100%
        }
      }
      .swiper-slide-thumb-active {
        opacity: 1;
      }
    }
    .swiper-slide {

      img{
        display: block;

        height: 8rem;
        object-fit: cover;
      }
    }


    .mySwiper2{
      height: 65%;
      width: 100%;
      --swiper-navigation-color: #c9a168;
      .swiper-slide{
        width:100%;
        background: #000;
        img{
          display: block;
          height:100%;
          object-fit: cover;
          margin:0 auto;
          max-width:100%;
        }
      }
      .downimg{
        position: absolute;
        bottom:1rem;
        right:2rem;
        z-index:10;
        color:#999999;
        font-weight: bold;
        font-size:1.1rem;
        cursor: pointer;
        background: url("../../../assets/images/downimg.png")no-repeat center 0;
        background-size:1.7rem auto;
        padding-top:2rem;
        box-sizing: border-box;
        height:4rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/photo/photo.vue